import {
  IResourceComponentsProps,
  useNavigation,
  useTable,
  useSelect,
  useList,
  useShow,
  useGetIdentity,
  useUpdate,
  useDelete,
  useImport,
  useCreateMany,
  useMany,
  CrudFilter,
  useUpdateMany,
} from '@pankod/refine-core'
import 'styles/custom.css'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  TableColumnType,
  Space,
  Typography,
  EditButton,
  DeleteButton,
  ShowButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  TagField,
  Progress,
  Menu,
  Tag,
  Form,
  Button,
  Popconfirm,
  message,
  Modal,
  Checkbox,
  Row,
  Col,
  Input,
  Select,
  Spin,
  Badge,
  useModal,
  Tabs,
  Divider,
  Grid,
} from '@pankod/refine-antd'

import { CSVLink } from 'react-csv'

import ReactMarkdown from 'react-markdown'
import { IGrade, IQuestion, IQuestionType, ISubject, ITeacherLevel, IQuestionStatus, ICheckList, IWorkRequest } from 'interfaces'
import { useCallback, useEffect, useState } from 'react'
import { TableColumnsType } from 'antd'
import { CreateQuestion } from 'pages/questions'
import { EditQuestion } from 'pages/questions'
import { QuestionFilter } from 'components/filters/questionFilter'
import metaData from 'metadata/questions'
import wrMetadata from 'metadata/workrequests'
import { getWorkRequestStatusCount, CompletionStatus, createMailForSecondReviewer, createMailForSecondApprover } from 'helpers'
import { MarkRetired } from './mark_retired'
import { ReactMarkdownAllowedElements } from 'helpers/markdownConfig'
import { getCount, getParentQuestionIds } from 'gql/query'
import { useUserContext } from 'context/user'
import { ExportQuestionsModal } from './export_questions_modal'
import { createLogForSecondApprover, createLogForSecondReviewer } from 'gql/mutations'
import { Source } from 'graphql'
import RichTextRender from './rich_text_render'
import { submitForApprovalOrReview } from 'helpers/multipleApprovalandMultipleReview'

// import { UploadQuestions } from './question_import_modal'
const { Search } = Input
const { PlusOutlined, ExportOutlined, MailOutlined, AppstoreOutlined, SettingOutlined, FilterOutlined, DeleteOutlined } = Icons
const { Text, Link } = Typography

type QuestionListProps = {
  request?: any
  updatePercentage?: any
}
type QuestionType = {
  title: string
  description: string
  created_by: string
  creator_id: string
  status: string
  subject_id: string
  theme_id: string
  sub_theme_id: string
  topic_id: string
  grade_ids: object[]
  option_type: string
  question_type_id: string
  bloom_level_id: string
  difficulty_level_id: string
  report_theme_id: string
  centa_standard_id: string
  strand_id: string
  centa_concept_id: string
  tn_taxonomy_id: string
  explanation_type_id: string
  competency_id: string
  teacher_level_id: string
  option_details: object[]
}
interface QuestionSearch {
  question_search: string
}

interface Count {
  forApprovalCount: number
  forReviewCount: number
  openCount: number
  openRequireAmendingCount: number
  publishedCount: number
  rejectedAtApprovalCount: number
  rejectedAtReviewCount: number
  requireAmendingCount: number
  retriedCount: number
  secondApprovalCount: number
  secondReviewCount: number
  totalCount: number
}

const { confirm } = Modal

export const QuestionTableList: React.FC<QuestionListProps> = ({ request, updatePercentage }) => {
  const { data: user } = useGetIdentity()
  const { userRole, qapproverList, qreviewerList } = useUserContext()
  const [enabledQuery, setEnableQuery] = useState(false)
  const { mutate } = useCreateMany<IQuestion>()
  const role = user?.defaultRole
  const { show } = useNavigation()
  const [form] = Form.useForm<IQuestion>()
  const [formSearch] = Form.useForm<QuestionSearch>()
  const [wrFilter, setWRFilter] = useState<CrudFilter[]>([])
  const [qFilter, setQFilter] = useState<CrudFilter[]>([])
  const [tableData, setTableData] = useState<object[]>([])
  const fileReader = new FileReader()
  const [file, setFile] = useState()
  const [loading, setLoading] = useState(false)
  const [messageHide, setHideMessage] = useState(false)
  const [array, setArray] = useState<object[]>([])
  const [totalValidQuestions, setTotalValidQuestions] = useState(0)
  const [tab, setTab] = useState('1')
  const { mutate: updateQuestionActiveFlag } = useUpdate()
  const [showTable, setShowTable] = useState<boolean>(true)
  const [showExportModal, setShowExportModal] = useState(false)
  const { modalProps: uploadProps, show: showUpload, close: closeUpload } = useModal()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [currentFilter, setCurrentFilter] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [parentQuestionIds, setParentQuestionIds] = useState([] as any[])
  const [currentRecord, setCurrentRecord] = useState('')
  const [totalVariantQuestionCount, setTotalVariantQuestionCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [processed, setProcessed] = useState(0)
  const [searchText, setSearchText] = useState('')
  const [questionCount, setQuestionCount] = useState<Count>({
    forApprovalCount: 0,
    forReviewCount: 0,
    openCount: 0,
    openRequireAmendingCount: 0,
    publishedCount: 0,
    rejectedAtApprovalCount: 0,
    rejectedAtReviewCount: 0,
    requireAmendingCount: 0,
    retriedCount: 0,
    secondApprovalCount: 0,
    secondReviewCount: 0,
    totalCount: 0,
  })
  const { mutate: updateSecondReviewers } = useUpdateMany<IQuestion>()
  const { mutate: updateSecondApprovers } = useUpdateMany<IQuestion>()
  const { mutate: updateActive } = useUpdateMany<IQuestion>()

  const findCount = useCallback(
    async (request: any) => {
      try {
        setLoading(true)
        let userId = user?.id
        let isAdmin = userRole === 'admin'
        let userrole = userRole
        const resource = 'questions'
        let subjectinchargeField =
          userrole === 'subjectincharge' && request?.subject_incharge_id !== undefined && request?.subject_incharge_id !== null
            ? 'subject_incharge_id'
            : 'created_by'
        const responseFindQuestionCount: any = await getCount({ userId, isAdmin, userrole, resource, subjectinchargeField })
        setLoading(false)
        let forApprovalCount = responseFindQuestionCount?.forApprovalCount?.aggregate?.count
        let forReviewCount = responseFindQuestionCount?.forReviewCount?.aggregate?.count
        let openCount = responseFindQuestionCount?.openCount?.aggregate?.count
        let openRequireAmendingCount = responseFindQuestionCount?.openRequireAmendingCount?.aggregate?.count
        let publishedCount = responseFindQuestionCount?.publishedCount?.aggregate?.count
        let rejectedAtApprovalCount = responseFindQuestionCount?.rejectedAtApprovalCount?.aggregate?.count
        let rejectedAtReviewCount = responseFindQuestionCount?.rejectedAtReviewCount?.aggregate?.count
        let requireAmendingCount = responseFindQuestionCount?.requireAmendingCount.aggregate?.count
        let retriedCount = responseFindQuestionCount?.retriedCount?.aggregate?.count
        let secondApprovalCount = responseFindQuestionCount?.secondApprovalCount?.aggregate?.count
        let secondReviewCount = responseFindQuestionCount?.secondReviewCount?.aggregate?.count
        let totalCount = parseInt(
          forApprovalCount +
            forReviewCount +
            openCount +
            openRequireAmendingCount +
            publishedCount +
            rejectedAtApprovalCount +
            rejectedAtReviewCount +
            requireAmendingCount +
            retriedCount +
            secondApprovalCount +
            secondReviewCount
        )
        // console.log(
        //   forApprovalCount,
        //   forReviewCount,
        //   openCount,
        //   openRequireAmendingCount,
        //   publishedCount,
        //   rejectedAtApprovalCount,
        //   rejectedAtReviewCount,
        //   requireAmendingCount,
        //   retriedCount,
        //   secondApprovalCount,
        //   secondReviewCount,
        //   'count'
        // )

        setQuestionCount({
          forApprovalCount,
          forReviewCount,
          openCount,
          openRequireAmendingCount,
          publishedCount,
          rejectedAtApprovalCount,
          rejectedAtReviewCount,
          requireAmendingCount,
          retriedCount,
          secondApprovalCount,
          secondReviewCount,
          totalCount,
        })
      } catch (err) {
        console.log(err, 'error')
      }
    },
    [user?.id, userRole, setLoading, setQuestionCount]
  )

  const multipleDetete = async () => {
    await updateActive(
      {
        resource: 'questions',
        ids: selectedRowKeys,
        values: {
          active: 'false',
        },
      },
      {
        onSuccess: () => {
          setSelectedRowKeys([])
        },
      }
    )
    await workRequestData?.refetch()
    const { total_valid_questions } = getWorkRequestStatusCount(workRequestData?.data?.data[0])
    setTotalValidQuestions(total_valid_questions)
  }

  useEffect(() => {
    let arr: any[] = []
    getParentQuestionIds().then((resp: any) => {
      resp?.questions?.forEach((element: any) => {
        arr?.push(element?.parent_question_id)
      })
    })
    setParentQuestionIds(arr)
  }, [])
  const handleOnSubmit = (fs: any) => {
    if (fs) {
      fileReader.onload = function (event: any) {
        const csvOutput = event.target.result
        csvFileToArray(csvOutput)
      }

      fileReader.readAsText(fs)
    }
  }

  // const handleChange = (e: any) => {
  //   setFile(e.target.files[0])
  //   setLoading(true)
  //   handleOnSubmit(e.target.files[0])
  // }
  const csvFileToArray = (result: string) => {
    const csvHeader = result.slice(0, result.indexOf('\n')).split(',')
    const csvRows = result.slice(result.indexOf('\n') + 1).split('\n')

    const array = csvRows.map(i => {
      const values = i.split(',')

      const obj = csvHeader.reduce((object: any, header: any, index: any) => {
        object[header] = values[index]

        return object
      }, {})
      return obj
    })

    setArray(array)
  }

  useEffect(() => {
    let question_arr: QuestionType[] = []
    let optionText = ['Option_A', 'Option_B', 'Option_C', 'Option_D']
    let fillText = ['Fill_Right_Answer_A', 'Fill_Right_Answer_B', 'Fill_Right_Answer_C', 'Fill_Right_Answer_D']
    let optionFlag = ['Option_Flag_A', 'Option_Flag_B', 'Option_Flag_C', 'Option_Flag_D']
    let insightText = ['Insight_A', 'Insight_B', 'Insight_C', 'Insight_D']
    let leftLabelText = ['Left_Label_A', 'Left_Label_B', 'Left_Label_C', 'Left_Label_D']
    let rightLabelTextt = ['Right_Label_A', 'Right_Label_B', 'Right_Label_C', 'Right_Label_D']
    let componentName = ['A', 'B', 'C', 'D']
    if (array.length > 0) {
      array.map((item: any) => {
        let option_details: object[] = []
        let option_flag = ''

        if (item?.Question_Type === 'MCQ') {
          optionText.map((options: any, i: any) => {
            if (item?.Correct_Answer === item[options]) {
              option_flag = 'Right Answer'
            } else {
              option_flag = item[optionFlag[i]]
              option_details.push({
                option_text: item[options],
                option_flag: option_flag,
                option_insight: item[insightText[i]],
              })
            }
          })
        } else if (item?.Question_Type === 'Fill') {
          fillText.map((rightans: any, i: any) => {
            option_details.push({
              right_answer: item[rightans],
              option_insight: item[insightText[i]],
            })
          })
        } else if (item?.Question_Type === 'Match') {
          leftLabelText.map((leftlab: any, i: any) => {
            option_details.push({
              left_label_text: item[leftlab],
              right_label_text: item[rightLabelTextt[i]],
              option_insight: item[insightText[i]],
            })
          })
        } else if (item?.Question_Type === 'ShortAnswer') {
          let cName = 'Component_'
          let rName = 'Rating_'
          let wName = 'Weightage_'
          componentName.map((comp: any, i: any) => {
            option_details.push({
              component_name: item[cName + comp],
              rating_1: item[rName + comp + 1],
              rating_2: item[rName + comp + 2],
              rating_3: item[rName + comp + 3],
              rating_4: item[rName + comp + 4],
              weightage: item[wName + comp],
            })
          })
        }
        if (item?.Title !== '') {
          question_arr.push({
            title: item?.Title,
            description: item?.Description,
            created_by: user?.id,
            creator_id: user?.id,
            status: item?.Status,
            subject_id: item?.Subject?.replace(/\,/g, ''),
            theme_id: item?.Theme === '' ? null : item?.Theme,
            sub_theme_id: item?.Sub_Theme === '' ? null : item?.Sub_Theme,
            topic_id: item?.Topic === '' ? null : item?.Topic,
            grade_ids: item?.Grade === '' ? null : item?.Grade,
            option_type: item?.Option_Type,
            question_type_id: item?.Question_Type,
            bloom_level_id: item?.Bloom_Level === '' ? null : item?.Bloom_Level,
            difficulty_level_id: item?.Difficulty_Level === '' ? null : item?.Difficulty_Level,
            report_theme_id: item?.Report_Theme === '' ? null : item?.Report_Theme,
            centa_standard_id: item?.Centa_Standard === '' ? null : item?.Centa_Standard,
            strand_id: item?.Strand === '' ? null : item?.Strand,
            centa_concept_id: item?.Centa_Concept === '' ? null : item?.Centa_Concept,
            tn_taxonomy_id: item?.Taxonomy === '' ? null : item?.Taxonomy,
            explanation_type_id: item?.Explanation_Type === '' ? null : item?.Explanation_Type,
            competency_id: item?.Competency === '' ? null : item?.Competency,
            teacher_level_id: item?.Teacher_Level === '' ? null : item?.Teacher_Level,
            option_details: option_details,
          })
        }
      })

      // mutate({
      //   resource: 'questions',
      //   values: question_arr,
      // })
    }
  }, [array])

  const handleOk = () => {
    setIsModalVisible(true)
  }
  const handleExportModalOk = () => {
    setShowExportModal(true)
  }
  const handleExportModalCance = () => {
    setShowExportModal(false)
  }
  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const showModal = (id: string) => {
    setCurrentRecord(id)
    setIsModalVisible(true)
  }

  useEffect(() => {
    setCurrent(1)
    if (request !== undefined && request?.id !== '' && request?.id !== null) {
      setHideMessage(true)
    } else if (userRole === 'qcreator' || userRole === 'variantcreator') {
      setTimeout(hideMessage, 5000)
    }
    findCount(request)
  }, [userRole, request])

  const [comments, setComments] = useState('')
  var selectedReasons: string[] = []
  const { setFilters: setWorkRequestFilters, tableQueryResult: workRequestData } = useTable<IWorkRequest>({
    resource: 'work_requests',
    queryOptions: {
      enabled: enabledQuery,
    },
    initialSorter: [
      {
        field: 'created_at',
        order: 'asc',
      },
    ],
    permanentFilter: [
      {
        field: 'active',
        operator: 'eq',
        value: 'true',
      },
      {
        field: 'id',
        operator: 'eq',
        value: request?.id,
      },
    ],
    metaData: wrMetadata,
  })

  const { filters, setFilters, tableQueryResult, sorter, current, setCurrent, pageCount, setPageSize } = useTable<IQuestion>({
    queryOptions: {
      enabled: enabledQuery,
    },
    resource: 'questions',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    initialFilter: [
      {
        field: 'work_request_id',
        operator: 'eq',
        value: request?.id,
      },
    ],
    permanentFilter: [
      { field: 'active', operator: 'eq', value: 'true' },
      { field: 'request_type', operator: 'ne', value: 'Uploaded' },
      { field: 'status', operator: 'ne', value: 'Draft' },
    ],
    metaData,
  })

  useEffect(() => {
    setShowTable(false)
  }, [filters])
  // console.log('tableQueryResult', tableQueryResult?.isFetching)
  //This is needed, because varaintcreator needs
  //access to all question in variant question creation
  useEffect(() => {
    let arrFilter: CrudFilter[] = []
    filters.splice(0, filters.length)
    setFilters([])

    setFilters([
      {
        field: 'work_request_id',
        operator: 'eq',
        value: request?.id,
      },
      {
        field: 'active',
        operator: 'eq',
        value: 'true',
      },
    ])
    if (userRole === 'subjectincharge') {
      arrFilter = []

      let subInchFilter: CrudFilter = { field: '', operator: 'eq', value: user?.id }
      if (request?.subject_incharge_id !== undefined && request?.subject_incharge_id !== null) {
        subInchFilter['field'] = 'work_request.subject_incharge_id'
      } else {
        subInchFilter['field'] = 'work_request.created_by'
      }
      arrFilter.push(
        // {
        //   field: 'work_request.created_by',
        //   operator: 'eq',
        //   value: user?.id,
        // },
        { ...subInchFilter },
        {
          field: 'work_request.status',
          operator: 'ne',
          value: 'Draft',
        }
      )
    } else if (userRole === 'variantcreator') {
      arrFilter = []
      arrFilter.push(
        {
          field: 'creator_id',
          operator: 'eq',
          value: user?.id,
        },
        {
          field: 'work_request.request_type',
          operator: 'eq',
          value: 'V',
        },
        {
          field: 'request_type',
          operator: 'eq',
          value: 'Q',
        },
        {
          field: 'work_request.status',
          operator: 'ne',
          value: 'Draft',
        }
      )
    } else if (userRole === 'qcreator') {
      arrFilter = []
      arrFilter.push(
        {
          field: 'creator_id',
          operator: 'eq',
          value: user?.id,
        },
        {
          field: 'work_request.status',
          operator: 'ne',
          value: 'Draft',
        },
        {
          field: 'work_request.request_type',
          operator: 'eq',
          value: 'Q',
        },
        {
          field: 'request_type',
          operator: 'eq',
          value: 'Q',
        }
      )
    } else if (userRole === 'qapprover') {
      arrFilter = []

      arrFilter.push(
        {
          operator: 'or',
          value: [
            {
              field: 'approver_id',
              operator: 'eq',
              value: user?.id,
            },
            {
              field: 'second_approver_id',
              operator: 'eq',
              value: user?.id,
            },
          ],
        },

        {
          field: 'work_request.status',
          operator: 'ne',
          value: 'Draft',
        },
        {
          field: 'status',
          operator: 'in',
          value: ['For Approval', 'Published', 'Rejected at Approval', 'For Review (Require Amending)', 'For Second Approval'],
        }
        // {
        //   operator: 'or',
        //   value: [
        //     {
        //       field: 'status',
        //       operator: 'eq',
        //       value: 'For Approval',
        //     },
        //     {
        //       field: 'status',
        //       operator: 'eq',
        //       value: 'Rejected at Approval',
        //     },
        //     {
        //       field: 'status',
        //       operator: 'eq',
        //       value: 'For Review (Require Amending)',
        //     },
        //     {
        //       field: 'status',
        //       operator: 'eq',
        //       value: 'Published',
        //     },
        //   ],
        // }
      )
    } else if (userRole === 'qreviewer') {
      arrFilter = []
      arrFilter.push(
        {
          operator: 'or',
          value: [
            {
              field: 'reviewer_id',
              operator: 'eq',
              value: user?.id,
            },
            {
              field: 'second_reviewer_id',
              operator: 'eq',
              value: user?.id,
            },
          ],
        },

        {
          field: 'work_request.status',
          operator: 'ne',
          value: 'Draft',
        },
        {
          operator: 'or',
          value: [
            {
              field: 'status',
              operator: 'eq',

              value: 'For Approval',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'Rejected at Approval',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'For Review (Require Amending)',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'Published',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'For Review',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'Open (Require Amending)',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'Rejected at Review',
            },
            {
              field: 'status',
              operator: 'eq',
              value: 'For Second Review',
            },
          ],
        }
      )
    }
    if (request?.id !== '' && request?.id !== undefined) {
      setFilters([
        {
          field: 'work_request_id',
          operator: 'eq',
          value: request?.id,
        },
      ])
    }
    setWRFilter(arrFilter)
    setQFilter(arrFilter)
    setFilters(arrFilter)
    setEnableQuery(true)
  }, [userRole, request])

  const { queryResult, setShowId } = useShow<IQuestion>({
    resource: 'questions',
    metaData,
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: createShow,
  } = useModalForm({
    resource: 'questions',
    action: 'create',
    redirect: false,
    metaData,
  })
  createModalProps.width = '100%'
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    close: editClose,
    show: editShow,
  } = useModalForm({
    resource: 'questions',
    action: 'edit',
    redirect: false,
    metaData,
  })
  editModalProps.width = '100%'
  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    message.error('Click on No')
  }
  const onChangeReasons = (checkedValues: any[]) => {
    selectedReasons = checkedValues
  }

  const changeFilters = (field: string, value: string, operator: any, isRemove: any) => {
    if (isRemove) {
      const updatedFilters = filters.filter((item: any) => item.field !== field)
      const removeIndex = filters.findIndex((item: any) => item.field === field)
      if (removeIndex !== -1) {
        filters.splice(removeIndex, 1)
        setFilters(updatedFilters)
      }
    } else {
      setCurrent(1)
      if (field !== 'all') {
        if (currentFilter === 'status') {
          filters.pop()
        }

        setFilters([
          {
            field: field,
            operator: operator,
            value: value,
          },
        ])
      } else if (field === 'all') {
        filters.splice(0, filters.length)
        if (request?.id !== '') {
          filters.splice(0, filters.length)
          setFilters(wrFilter)
          setFilters([
            {
              field: 'work_request_id',
              operator: 'eq',
              value: request?.id,
            },
            {
              field: 'active',
              operator: 'eq',
              value: 'true',
            },
          ])
        }
      }

      setCurrentFilter(field)
    }
  }
  const hideMessage = () => {
    setHideMessage(true)
  }

  const breakpoint = Grid.useBreakpoint()

  // useEffect(() => {
  //   let arr: object[] = []
  //   let optionText = ['option_a', 'option_b', 'option_c', 'option_d']
  //   let optionFlags = ['option_flag_a', 'option_flag_b', 'option_flag_c', 'option_flag_d']
  //   let option_arr: object[] = []
  //   let option_flag_arr: object[] = []
  //   let correct_ans: string = ''
  //   let insight_arr: object[] = []
  //   let insightText = ['insight_a', 'insight_b', 'insight_c', 'insight_d']
  //   let left_label_text = ['left_label_1', 'left_label_2', 'left_label_3', 'left_label_4']
  //   let left_label_arr: object[] = []
  //   let right_label_text = ['right_label_1', 'right_label_2', 'right_label_3', 'right_label_4']
  //   let right_label_arr: object[] = []
  //   let rating_arr: object[] = []
  //   let rating_text = ['rating_1', 'rating_2', 'rating_3', 'rating_4']
  //   let component_arr: object[] = []
  //   let component_text = ['component_1', 'component_2', 'component_3', 'component_4']

  //   let weightage_arr: object[] = []
  //   let weightage_text = ['weightage_1', 'weightage_2', 'weightage_3', 'weightage_4']

  //   exportQuestions().then((response: any) => {
  //     // setCreatorList(response.users)

  //     if (response?.questions?.length > 0) {
  //       response?.questions?.map((item: any, index: any) => {
  //         if (item?.question_type_id == 'MCQ') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           option_flag_arr = []
  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               // arr[index][optionText[i]]= option?.option_text

  //               option_arr.push({
  //                 [optionText[i]]: option?.option_text,
  //               })

  //               if (option?.option_flag === 'Right Answer') {
  //                 correct_ans = option?.option_text
  //               }
  //               option_flag_arr.push({
  //                 [optionFlags[i]]: option?.option_flag,
  //               })
  //               insight_arr.push({
  //                 [insightText[i]]: option?.option_insight,
  //               })
  //             })
  //         } else if (item?.question_type_id == 'Fill') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               correct_ans = correct_ans?.concat(option?.right_answer)
  //               correct_ans = correct_ans?.concat(',')
  //             })
  //         } else if (item?.question_type_id == 'Match') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []

  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               left_label_arr.push({
  //                 [left_label_text[i]]: option?.left_label_text,
  //               })
  //               right_label_arr.push({
  //                 [right_label_text[i]]: option?.right_label_text,
  //               })

  //               insight_arr.push({
  //                 [insightText[i]]: option?.option_insight,
  //               })
  //             })
  //         } else {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           rating_arr = []
  //           component_arr = []
  //           weightage_arr = []

  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               component_arr.push(option)
  //             })
  //         }

  //         arr.push({
  //           subject_code: item?.subject?.code,
  //           subject: item?.subject?.name,
  //           theme: item?.theme?.name,
  //           sub_theme: item?.sub_theme?.name,
  //           topic: item?.topic?.name,
  //           grade: item?.grade?.name,
  //           taxonomy: item?.tn_taxonomy?.name,
  //           difficulty_level: item?.difficulty_level?.name,
  //           bloom_level: item?.bloom_level?.name,
  //           strand: item?.strand?.name,
  //           status: item?.status,
  //           creator: item?.userByCreatorId?.displayName,
  //           question_type: item?.question_type_id,
  //           title: item?.title?.replace(/<[^>]+>/g, ''),
  //           options: option_arr,
  //           option_flags: option_flag_arr,
  //           left_label_arr: left_label_arr,
  //           right_label_arr: right_label_arr,
  //           correct_answer: correct_ans,
  //           insight: insight_arr,
  //           rating_arr: rating_arr,
  //           component_name: component_arr,
  //           weightage: weightage_arr,
  //           creator_comments: item?.creator_notes,
  //           reviewer_comments: item?.reviewer_notes,
  //           approver_comments: item?.approver_notes,

  //           reviewer_stem_comments: item?.reviewer_stem_comments,
  //           approver_stem_comments: item?.approver_stem_comments,
  //           question_insight: item?.question_insight,
  //         })
  //       })
  //     }
  //   })

  //   setTableData(arr)
  // }, [])
  // const gradeList = useList<IGrade>({
  //   resource: 'grades',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   config: {
  //     pagination: { pageSize: 1000 },
  //   },
  // })

  const columns: TableColumnsType<IQuestion> = [
    {
      dataIndex: 'question_id',
      title: 'Id',
      width: 100,
      key: 'question_id',
      fixed: 'left',
      render: (_, record) => (
        <Text
          style={{
            width: 100,
            textAlign: 'left',
          }}
        >
          {record?.question_id}
          {'  '}
          {userRole === 'qreviewer' && record?.status === 'For Second Review' ? (
            <>
              <Tag color="geekblue">R2</Tag>
            </>
          ) : null}
          {userRole === 'qapprover' && record?.status === 'For Second Approval' ? (
            <>
              <Tag color="geekblue">A2</Tag>
            </>
          ) : null}
        </Text>
      ),
    },

    {
      title: 'Name',
      dataIndex: 'name',
      width: 200,
      key: 'name',
      fixed: breakpoint.sm ? 'left' : undefined,
      render: (_, record) => (
        <ShowButton
          size="small"
          type="link"
          icon={null}
          recordItemId={record?.id}
          onClick={() => {
            show('questions', record?.id)
          }}
        >
          <Text
            style={{
              width: 150,
              textAlign: 'left',
              color: '#6659FF',
              cursor: 'pointer',
            }}
            ellipsis={{ tooltip: record?.title }}
          >
            {/* <ReactMarkdown
              allowedElements={ReactMarkdownAllowedElements}
              components={{
                p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
              }}
            >
              {record?.title.length < 30 ? record?.title.substring(0, 30) : record?.title.substring(0, 30).concat('...')}
            </ReactMarkdown> */}
            <RichTextRender content={record?.title} />
          </Text>
        </ShowButton>
      ),
    },
    {
      dataIndex: 'question_type_id',
      title: 'Q Type',
    },
    {
      dataIndex: 'grade_ids',
      title: 'Grade',
      render: (_, { question_grades, grade_ids }) => (
        <>
          {question_grades?.length > 0 ? (
            <div>
              {question_grades?.length > 1 ? (
                <Badge size="small" count={question_grades?.length - 1} style={{ background: '#6659ff' }}>
                  {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                  <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                    {question_grades?.[0]?.grade?.name}
                  </Tag>
                  {/* </Tooltip> */}
                </Badge>
              ) : (
                <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                  {question_grades[0]?.grade?.name}
                </Tag>
              )}
            </div>
          ) : null}
        </>
      ),
    },
    {
      dataIndex: 'status',
      title: 'Status',
      className: request ? 'show' : userRole === 'qcreator' || userRole === 'qreviewer' ? 'hide' : 'show',
      width: 100,
      // className:{ userRole=='qcreator'?`hide-col`:`ant-table-column-sort`},

      render: value => (
        <Tag
          color={
            value === 'Published'
              ? 'green'
              : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
              ? 'volcano'
              : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'topic_id',
      title: 'Topic',
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.topic?.name }}>
          {record?.topic?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'difficulty_level_id',
      title: 'Difficulty',
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.difficulty_level?.name }}>
          {record?.difficulty_level?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'bloom_leve_ids',
      title: `Bloom's Level`,
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.bloom_level?.name }}>
          {record?.bloom_level?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'work_request',
      title: 'WR Name',
      render: (_, record) => (
        <Text style={{ width: 100, textAlign: 'left' }} ellipsis={{ tooltip: record?.work_request?.name }}>
          {record?.work_request?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'report_theme_id',
      title: 'Report Theme',

      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.report_theme?.name }}>
          {record?.report_theme?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'theme_id',
      title: 'Theme',

      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.theme?.name }}>
          {record?.theme?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'sub_theme_id',
      title: 'Sub Theme',

      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.sub_theme?.name }}>
          {record?.sub_theme?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'centa_standard',
      title: 'Standards',

      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.work_request?.strands?.name || record?.strand?.name }}>
          {record?.work_request?.strands?.name || record?.strand?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'competencies',
      title: 'Competency',

      render: (_, record) => (
        <Text
          style={{ width: 175, textAlign: 'left' }}
          ellipsis={{ tooltip: record?.work_request?.competencies?.name || record?.competencies?.name }}
        >
          {record?.work_request?.competencies?.name || record?.competencies?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'creator_id',
      title: 'Creator',
      className: userRole === 'qapprover' || userRole === 'qreviewer' ? 'hide' : 'show',
      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
          {record?.userByCreatorId?.displayName}
        </Text>
      ),
    },
    {
      dataIndex: 'reviewer_id',
      title: 'Reviewer',
      className: userRole === 'qapprover' || userRole === 'qcreator' ? 'hide' : 'show',
      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByReviewerId?.displayName }}>
          {record?.userByReviewerId?.displayName}
        </Text>
      ),
    },
    {
      dataIndex: 'approver_id',
      className: userRole === 'qreviewer' || userRole === 'qcreator' ? 'hide' : 'show',
      title: 'Approver',
      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByApproverId?.displayName }}>
          {record?.userByApproverId?.displayName}
        </Text>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      fixed: breakpoint.md ? 'right' : undefined,
      width: 100,
      render: (_, record: IQuestion) => (
        <Space>
          {userRole === 'admin' ||
          (userRole === 'variantcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
          (userRole === 'qcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
          (userRole === 'qreviewer' &&
            (record?.status === 'For Review' ||
              record?.status === 'For Second Review' ||
              record?.status === 'For Review (Require Amending)' ||
              record?.status === 'Second Review Verified')) ||
          userRole === 'qbincharge' ||
          (userRole === 'qapprover' && (record?.status === 'For Approval' || record?.status === 'For Second Approval')) ? (
            <EditButton
              hidden={
                (request?.request_type === 'V' && userRole === 'qcreator') ||
                (request?.request_type === 'Q' && userRole === 'variantcreator') ||
                (userRole === 'qreviewer' &&
                  record?.status === 'For Review' &&
                  record?.second_reviewer_id === user?.id &&
                  record?.reviewer_id !== record?.second_reviewer_id) ||
                (userRole === 'qapprover' &&
                  record?.status === 'For Approval' &&
                  record?.second_approver_id === user?.id &&
                  record?.approver_id !== record?.second_approver_id)
              }
              key="edit"
              size="small"
              type="link"
              hideText
              recordItemId={record.id}
              onClick={() => {
                editShow(record?.id)
                setShowId(record?.id)
              }}
            />
          ) : null}
          {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
            <Button type="primary" onClick={() => showModal(record?.id)}>
              Mark Retired
            </Button>
          ) : null}
          {userRole === 'admin' ||
          (userRole === 'qcreator' && record?.status === 'Open') ||
          (userRole === 'variantcreator' && record?.status === 'Open') ? (
            <Popconfirm
              title="Are you sure ?"
              okText="Yes"
              cancelText="No"
              onConfirm={async () => {
                await updateQuestionActiveFlag({ resource: 'questions', id: record?.id, values: { active: 'false' } })
                await changeStatus(request)
              }}
              // onConfirm={(e: any) => ifConfirm(e, record.id,request)}
            >
              <Button
                danger
                size="small"
                type="link"
                icon={null}
                hidden={
                  (request?.request_type === 'V' && userRole === 'qcreator') || (request?.request_type === 'Q' && userRole === 'variantcreator')
                }
              >
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          ) : null}
          {/* {
            parentQuestionIds?.includes(record?.id)?
            <Button
            title='See Variants'
            
            size="small"
            type="link"
            icon={null}>
            <Icons.InfoCircleOutlined/>
 
 </Button>:null
          }   */}
        </Space>
      ),
    },
  ]
  const onChange = (page: number, pageSize: number): void => {
    setCurrent(page)
    setPageSize(pageSize)
  }

  useEffect(() => {
    const { total_valid_questions } = getWorkRequestStatusCount(request)
    setTotalValidQuestions(total_valid_questions)
  }, [request])

  const changeStatus = async (request: any) => {
    await findCount(request)
    workRequestData?.refetch()
    // getWorkRequestStatusCount(workRequestData?.data?.data[0])
    const { total_valid_questions } = getWorkRequestStatusCount(workRequestData?.data?.data[0])
    setTotalValidQuestions(total_valid_questions)
    updatePercentage()
  }

  useEffect(() => {
    if (request?.request_type === 'V') {
      let _totalVariantQuestionCount = 0
      request?.variant_options?.forEach((item: any) => {
        _totalVariantQuestionCount = _totalVariantQuestionCount + JSON.parse(item?.variant_count)
      })
      setTotalVariantQuestionCount(_totalVariantQuestionCount)
    }
  }, [request])
  const { handleChange } = useImport<IQuestionType>({
    onFinish: results => {
      window.alert(JSON.stringify(results))
    },
    onProgress: ({ totalAmount, processedAmount }) => {
      //  setProcessed(processedAmount)
      //  setTotal(totalAmount)
    },
  })

  const onSelectChange = (selectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(selectedRowKeys)
  }

  // let selectionEnabled=userRole === 'qcreator'? 'hide' : 'show'
  // const selectionEnabled=userRole==="qcreator"?false:true
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
    getCheckboxProps: (record: any) => {
      return {
        disabled:
          request?.id === null || request?.id === undefined
            ? true
            : (userRole === 'qcreator' || userRole === 'variantcreator') &&
              (record?.status === 'Open' || record?.status === 'Open (Require Amending)')
            ? false
            : userRole === 'qreviewer' &&
              (record?.status === 'For Review' || record?.status === 'Second Review' || record?.status === 'For Review (Require Amending)')
            ? false
            : userRole === 'qapprover' && (record?.status === 'For Approval' || record?.status === 'Second Approval')
            ? false
            : true,
      }
    },
  }

  //----------
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  //   selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
  //   getCheckboxProps: (record: any) => ({
  //     disabled:
  //       userRole !== 'qreviewer' && userRole !== 'qapprover'
  //         ? true
  //         : userRole === 'qreviewer'
  //           ? record?.status === 'For Review'
  //             ? false
  //             : true
  //           : false || userRole === 'qapprover'
  //             ? record?.status === 'For Approval'
  //               ? false
  //               : true
  //             : false,
  //     className: userRole === 'qcreator' ? 'hide' : 'show-check',

  //     // Column configuration not to be checked
  //     // name: record.name,
  //   }),
  // }
  //-------------

  const hasSelected = selectedRowKeys.length > 0

  const onFinishApprover = (values: any) => {
    if (userRole === 'qapprover') {
      updateSecondReviewers(
        {
          resource: 'questions',
          ids: selectedRowKeys,
          values: {
            second_approver_id: values?.second_approver_id,
            status: 'For Second Approval',
          },
        },
        {
          onSuccess: () => {
            selectedRowKeys?.forEach((item: any) => {
              let result = qapproverList.filter((appUser: any) => appUser?.id === values?.second_approver_id)[0]
              createMailForSecondApprover(item, result?.displayName, result?.email)
              tableQueryResult?.data?.data?.forEach((quesions: IQuestion) => {
                if (item === quesions?.id) createLogForSecondApprover(quesions?.approver_id, values?.second_approver_id, item)
              })
              setSelectedRowKeys([])
              // createMailForSecondReviewer(item,result?.user?.displayName,result?.user?.email)
            })
          },
        }
      )
    }
  }
  const multipleActions = async (status: string) => {
    setLoading(true)
    const response = await submitForApprovalOrReview(status, selectedRowKeys, request, userRole, qreviewerList, user, qapproverList)
    if (response?.message) {
      message.error(response.message)
    }
    setLoading(false)
    setSelectedRowKeys([])
    tableQueryResult?.refetch()
  }

  const onFinish = async (values: any) => {
    if (userRole === 'qreviewer') {
      updateSecondReviewers(
        {
          resource: 'questions',
          ids: selectedRowKeys,
          values: {
            second_reviewer_id: values?.second_reviewer_id,
            status: 'For Second Review',
          },
        },
        {
          onSuccess: () => {
            selectedRowKeys?.forEach((item: any) => {
              let result = qreviewerList.filter((appUser: any) => appUser?.id === values?.second_reviewer_id)[0]
              createMailForSecondReviewer(item, result?.displayName, result?.email)
              tableQueryResult?.data?.data?.forEach((quesions: IQuestion) => {
                if (item === quesions?.id) createLogForSecondReviewer(quesions?.reviewer_id, values?.second_reviewer_id, item)
              })

              setSelectedRowKeys([])
            })
          },
        }
      )
    }
  }
  const questionSearch = (value: any) => {
    console.log('hwllow')
    let numValue = Number(value)
    setFilters(prevFilters => {
      const updatedFilters = prevFilters.filter((item: any) => item.field !== 'question_id' && item.field !== 'title')
      if (!isNaN(numValue) && value.trim() !== '') {
        return [
          ...updatedFilters,
          {
            field: 'question_id',
            operator: 'eq',
            value: numValue,
          },
        ]
      } else {
        return [
          ...updatedFilters,
          {
            field: 'title',
            operator: 'contains',
            value: `%${value}%`,
          },
        ]
      }
    })
  }

  const clearSearch = () => {
    filters.splice(0, filters.length)
    setFilters([])

    formSearch?.resetFields()
    setSearchText('')
    setFilters(qFilter)
    // tableQueryResult?.refetch()
  }
  const labels: { keyName: keyof Count; labelName: string }[] = [
    { keyName: 'totalCount', labelName: 'Total Questions Created' },
    { keyName: 'openCount', labelName: 'Open Questions' },
    { keyName: 'forReviewCount', labelName: 'Questions for Review' },
    { keyName: 'retriedCount', labelName: 'Retired Questions' },
    { keyName: 'publishedCount', labelName: 'Published Questions' },
    { keyName: 'rejectedAtApprovalCount', labelName: 'Rejected At Approval Questions' },
    { keyName: 'forApprovalCount', labelName: 'For Approval Questions' },
    { keyName: 'rejectedAtReviewCount', labelName: 'Rejected At Review Questions' },
    { keyName: 'requireAmendingCount', labelName: 'Amending Required Questions' },
    { keyName: 'secondApprovalCount', labelName: 'For Second Approval Questions' },
    { keyName: 'openRequireAmendingCount', labelName: 'Open (Require Amending) Questions' },
    { keyName: 'secondReviewCount', labelName: 'For Second Review Questions' },
  ]
  return (
    <>
      <List
        title="Questions"
        pageHeaderProps={{
          extra: [
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {userRole === 'admin' || userRole === 'srmanager' || userRole === 'subjectincharge' || userRole === 'qbincharge' ? (
                  <>
                    {request?.id === '' ||
                      request?.id === null ||
                      (request?.id === undefined && (
                        <Button icon={<ExportOutlined />} onClick={handleExportModalOk}>
                          {' '}
                          Export
                        </Button>
                      ))}
                  </>
                ) : // </CSVLink>
                null}

                <RefreshButton
                  key="refresh"
                  onClick={() => {
                    // clearSearch()

                    tableQueryResult?.refetch()
                  }}
                  style={{ marginLeft: 10 }}
                />
              </div>
              <>
                {request?.request_type === 'V'
                  ? userRole === 'variantcreator' &&
                    request?.creator_id === user?.id &&
                    request?.status !== 'Draft' && (
                      <CreateButton
                        disabled={
                          request?.request_type === 'V' ? !(totalValidQuestions < totalVariantQuestionCount) : !(totalValidQuestions < request?.count)
                        }
                        key="create"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          createFormProps.form?.resetFields()
                          createShow()
                        }}
                        hidden={!request?.id}
                      />
                    )
                  : request?.request_type === 'Q'
                  ? userRole === 'qcreator' &&
                    request?.creator_id === user?.id &&
                    request?.status !== 'Draft' && (
                      <CreateButton
                        disabled={
                          request?.request_type === 'V' ? !(totalValidQuestions < totalVariantQuestionCount) : !(totalValidQuestions < request?.count)
                        }
                        key="create"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          createFormProps.form?.resetFields()
                          createShow()
                        }}
                        hidden={!request?.id}
                      />
                    )
                  : null}
              </>
            </>,
          ],
        }}
      >
        {(userRole === 'qcreator' || userRole === 'variantcreator') && selectedRowKeys.length > 0 && (
          <div>
            <Popconfirm
              title="Are you sure, Do you want to delete items?"
              okText="Confirm"
              cancelText="No"
              onCancel={() => console.log('ook')}
              onConfirm={async () => await multipleDetete()}
            >
              <Button danger>Delete</Button>
            </Popconfirm>

            <Popconfirm
              title="Are you sure, Do you want to send this items for review?"
              okText="Confirm"
              cancelText="No"
              onCancel={() => console.log('ook')}
              onConfirm={async () => await multipleActions('For Review')}
            >
              <Button style={{ marginLeft: '5px' }} loading={loading} type="dashed">
                Submit For Review
              </Button>
            </Popconfirm>

            <Divider />
          </div>
        )}

        {request?.id === null ||
          (request?.id === undefined &&
            (loading ? (
              <Spin style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
            ) : (
              <>
                <Divider />
                <Row gutter={[16, 16]}>
                  {labels.map(countDetails => {
                    if (questionCount[countDetails.keyName] && questionCount[countDetails.keyName] > 0) {
                      return (
                        <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                          <div
                            style={{
                              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                              padding: '1rem',
                              height: '4rem',
                              borderRadius: '10px',
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <h4>
                              {countDetails?.labelName}:
                              <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>
                                {questionCount[countDetails.keyName] || 0}
                              </span>
                            </h4>
                          </div>
                        </Col>
                      )
                    }
                  })}
                </Row>
                <Divider />
              </>
            )))}

        {userRole === 'qreviewer' && (
          <Form form={form} onFinish={onFinish}>
            <Row style={{ display: !hasSelected ? 'none' : 'flex' }} gutter={[16, 0]}>
              <Col lg={10}>
                <Form.Item name="second_reviewer_id" rules={[{ required: hasSelected }]}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Select Second Reviewer"
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {qreviewerList?.length > 0 &&
                      qreviewerList?.map(item =>
                        item?.id !== user?.id ? (
                          <option key={item?.id} value={item?.id}>
                            {item?.displayName}
                          </option>
                        ) : null
                      )}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={4}>
                <Button type="primary" htmlType="submit">
                  Assign
                </Button>
              </Col>
              <Col lg={10}>
                <span style={{ marginLeft: 8 }}>{hasSelected ? `Selected ${selectedRowKeys.length} Questions` : ''}</span>
              </Col>
            </Row>
          </Form>
        )}

        {userRole === 'qreviewer' && selectedRowKeys.length > 0 && (
          <div style={{ marginBottom: '5px' }}>
            <Popconfirm
              title="Are you sure, Do you want to send this items for Approval?"
              okText="Confirm"
              cancelText="No"
              onCancel={() => console.log('ook')}
              onConfirm={async () => await multipleActions('For Approval')}
            >
              <Button
                style={{
                  marginTop: '5px',
                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                  borderRadius: '10px',
                  backgroundColor: '#1890ff',
                  color: '#fff',
                }}
                loading={loading}
                type="dashed"
              >
                Submit For Approval
              </Button>
            </Popconfirm>
          </div>
        )}

        {userRole === 'qapprover' && (
          <Form form={form} onFinish={onFinishApprover}>
            <Row style={{ display: !hasSelected ? 'none' : 'flex' }} gutter={[16, 0]}>
              <Col lg={10}>
                <Form.Item name="second_approver_id" rules={[{ required: hasSelected, message: 'Please Select an approver' }]}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Select Second Approver"
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {qapproverList?.length > 0 &&
                      qapproverList?.map(item =>
                        item?.id !== user?.id ? (
                          <option key={item?.id} value={item?.id}>
                            {item?.displayName}
                          </option>
                        ) : null
                      )}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={4}>
                <Button type="primary" htmlType="submit">
                  Assign
                </Button>
              </Col>
              <Col lg={10}>
                <span style={{ marginLeft: 8 }}>{hasSelected ? `Selected ${selectedRowKeys.length} Questions` : ''}</span>
              </Col>
            </Row>
          </Form>
        )}

        {/* multiple publish */}
        {userRole === 'qapprover' && selectedRowKeys.length > 0 && (
          <Popconfirm
            title="Are you sure, Do you want to Publish this questions?"
            okText="Confirm"
            cancelText="No"
            onCancel={() => console.log('ook')}
            onConfirm={async () => await multipleActions('Published')}
          >
            <Button
              style={{
                marginTop: '5px',
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                borderRadius: '10px',
                backgroundColor: '#1890ff',
                color: '#fff',
              }}
              loading={loading}
              type="dashed"
            >
              Submit for Publish
            </Button>
          </Popconfirm>
        )}

        {request?.id === null || request?.id === undefined ? (
          <>
            <Form form={formSearch}>
              <Row gutter={[16, 0]} style={{ alignItems: 'center' }}>
                <Col lg={22}>
                  <Search
                    name="question_search"
                    placeholder="input search text"
                    enterButton="Search"
                    size="large"
                    onSearch={questionSearch}
                    value={searchText}
                    onChange={(e: any) => {
                      setSearchText(e?.target?.value)
                    }}
                  />
                </Col>
                <Col lg={2}>
                  <Button htmlType="button" onClick={clearSearch}>
                    Clear{' '}
                  </Button>
                </Col>
              </Row>
            </Form>
            <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
          </>
        ) : null}

        {/* {console.log('loading', tableQueryResult?.isLoading)} */}

        {(userRole === 'qcreator' || userRole === 'variantcreator') && messageHide === false ? (
          <Typography.Text type="warning">Add Questions in Work Request page.</Typography.Text>
        ) : null}
        <QuestionFilter changeFilters={changeFilters} source={'Questions'} hideFilters={[]} />
        {/* <Tabs defaultActiveKey={tab} onChange={activeTab => setTab(activeTab)}>
        <Tabs.TabPane tab="Created" key="1"> */}
        {/* {!showTable ? ( */}
        <Table
          size="small"
          scroll={{ x: true }}
          dataSource={tableQueryResult?.data?.data}
          rowSelection={rowSelection}
          columns={columns}
          rowKey="id"
          loading={tableQueryResult?.isLoading}
          pagination={{
            total: tableQueryResult?.data?.total,
            onChange,
          }}
          expandable={{
            expandedRowRender: record => <Table columns={columns} dataSource={record?.variant_questions} scroll={{ x: 1500 }} />,
            rowExpandable: record => parentQuestionIds?.includes(record?.id),
          }}
        />
        {/* ) : null} */}
        {/* </Tabs.TabPane>
        {userRole === 'admin' || userRole === 'qcreator' || userRole === 'variantcreator' ? ( */}
        {/* <Tabs.TabPane tab="Uploaded" key="2">
            <Table
              size="small"
              dataSource={uploadedData?.data?.data}
              columns={columns}
              loading={uploadedData?.isLoading}
              pagination={{
                total: uploadedData?.data?.total,
                onChange: onChangeUpload,
              }}
            /> */}

        <MarkRetired isModalVisible={isModalVisible} handleOk={handleOk} handleCancel={handleCancel} id={currentRecord} />
        <ExportQuestionsModal isModalVisible={showExportModal} handleOk={handleExportModalOk} handleCancel={handleExportModalCance} />
        <CreateQuestion modalProps={createModalProps} formProps={createFormProps} request={request} updatePercentage={updatePercentage} />

        <EditQuestion
          modalProps={editModalProps}
          formProps={editFormProps}
          record={record}
          close={editClose}
          updatePercentage={updatePercentage}
          source={'questions_list'}
        />
        {/* <UploadQuestions modalProps={uploadProps} close={closeUpload} reloadUploadedData={reloadUploadedData} /> */}
      </List>
    </>
  )
}
